export { BootstrapModalModule } from "./bootstrap-modal.module";
export { DialogComponent } from "./dialog.component";
export {
  DialogService,
  DialogOptions,
  DialogServiceConfig
} from "./dialog.service";



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/dialog/index.ts